import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-portfolio',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class PortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  	$.getScript("../assets/js/custom.js");
  }

}
